import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// winepassport-api#60 — Allaria+ devuelve al pagador a una única URL por cuenta con ?purchaseId=&state= (solo purchaseId identifica la orden; state no se usa).
// Las compras de pruebas locales llevan el prefijo LOC-: si caen en otro host (nunca en prod), se reenvían a localhost.
// El resto va a la pantalla de vuelta (fuera del guard, que pisaría la query al mandar al login).
const returnParams = new URLSearchParams(window.location.search);
const returnedPurchaseId = returnParams.get('purchaseId');
if (returnedPurchaseId && !window.location.pathname.startsWith('/checkout/allaria-return')) {
  const isLocalHost = window.location.hostname === 'localhost';
  if (!environment.production && returnedPurchaseId.startsWith('LOC-') && !isLocalHost) {
    window.location.replace(`http://localhost:4200/checkout/allaria-return${window.location.search}`);
  } else {
    window.location.replace(`/checkout/allaria-return${window.location.search}`);
  }
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
